import ajax from '../../common/services/httpService'

export function getPadPresenceTesting(siteId, params, options = {}) {
	return ajax.get(`employee/pad-presence-testing/${siteId}`, null, params, options)
}
